import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function LandingPage() {
  return (
    <div className="flex min-h-screen flex-col">
      {/* Nav */}
      <header className="flex items-center justify-between px-6 py-4 border-b">
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="DALY" className="h-8 w-8 rounded-lg" />
          <span className="font-bold text-xl">DALY</span>
        </div>
        <div className="flex items-center gap-3">
          <Button variant="ghost" asChild><Link to="/login">Sign In</Link></Button>
          <Button className="bg-brand-primary hover:bg-brand-primary-dark" asChild><Link to="/signup">Get Started</Link></Button>
        </div>
      </header>

      {/* Hero */}
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-2xl text-center">
          <h1 className="text-5xl font-extrabold tracking-tight bg-gradient-to-r from-brand-primary via-brand-primary-light to-blue-500 bg-clip-text text-transparent">
            One Platform, Total Clarity
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            Manage goals, sprints, and tasks with built-in time tracking, evaluations, and performance scoring.
          </p>
          <div className="mt-8 flex items-center justify-center gap-4">
            <Button size="lg" className="bg-brand-secondary hover:bg-brand-secondary-light text-white" asChild>
              <Link to="/signup">Start Free Today</Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="/login">Sign In</Link>
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
